import Console from 'utility/Debug/Console';

export const getCookieValue = (name: string) => {
    const cookieEntry = document.cookie.split('; ').find((cookie) => {
        return cookie.startsWith(`${name}=`);
    });

    return cookieEntry?.split('=')[1] ?? '';
};

export const setCookieValue = (
    name: string,
    value: string,
    lifeTime?: number
) => {
    const prefix = location.hostname !== 'localhost' ? '.' : '';
    const cookieDomain = `domain=${prefix}${location.hostname}`;
    let expires = '';

    if (lifeTime) {
        if (lifeTime > 0) {
            const d = new Date();
            d.setTime(d.getTime() + lifeTime * 1000);
            expires = `; expires=${d.toUTCString()}`;
        } else if (lifeTime < 0) {
            expires = '; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        }
    }

    // no breaks allowed in the cookie string
    /* eslint-disable */
    document.cookie = `${name}=${encodeURIComponent(
        value
    )}${expires}; path=/; ${cookieDomain}; SameSite=lax`;
    /* eslint-enable */
};

export function setCookieJsonValue<Type>(
    name: string,
    value: Type,
    lifeTime: number
) {
    setCookieValue(name, JSON.stringify(value), lifeTime);
}

export function getCookieJsonValue<Type>(cookieName: string) {
    try {
        const data = decodeURI(getCookieValue(cookieName));
        return JSON.parse(data) as Type;
    } catch (error) {
        Console.error(error);
        return {} as Partial<Type>;
    }
}
